export const slideDelay = 7;
export const slideDuration = 0.8;
